import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  DRAWERSTATE_FEATURE_KEY,
  State,
  DrawerStatePartialState
} from './drawer-state.reducer';

// Lookup the 'DrawerState' feature state managed by NgRx
export const getDrawerStateState = createFeatureSelector<
  DrawerStatePartialState,
  State
>(DRAWERSTATE_FEATURE_KEY);

export const getDrawers = createSelector(
  getDrawerStateState,
  (state: State) => state.drawers
);

export const getDrawerStatePopped = createSelector(
  getDrawerStateState,
  (state: State) => state.popped
);